module.exports = ".container-loading {\n  width: 35px;\n  height: 35px;\n  margin: 0 auto; }\n  .container-loading .loading {\n    margin: 100px 0 0 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/minha-conta/lancamentos-futuros/lancamentos-futuros.component.scss
// module id = ./src/app/modules/dashboard/components/minha-conta/lancamentos-futuros/lancamentos-futuros.component.scss
// module chunks = main